import { PRODUCT_TYPE } from 'configs/constants';
import PaymentMethod from 'pages/PaymentMethodScreen/paymentMethod';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TProductType } from 'typings';
import {
  APP_BUTTON_TYPES,
  isRunningInWebView,
  showAppButton
} from 'utils/webviewHelpers';

function PaymentMethodScreen() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const productType =
    (query.get('productType') as TProductType) || PRODUCT_TYPE.HOME_SECURITY;

  console.log('productType', productType);

  useEffect(() => {
    if (isRunningInWebView()) {
      showAppButton(APP_BUTTON_TYPES.RELOAD, APP_BUTTON_TYPES.CLOSE);
    }
  }, []);

  const handleAddNewCardToggle = (isOpen: boolean) => {
    if (isRunningInWebView()) {
      if (isOpen) {
        // hideAppButton();
        showAppButton(APP_BUTTON_TYPES.RELOAD);
      } else {
        showAppButton(APP_BUTTON_TYPES.RELOAD, APP_BUTTON_TYPES.CLOSE);
      }
    }
  };

  return (
    <PaymentMethod
      onAddNewCardToggle={handleAddNewCardToggle}
      productType={productType}
    />
  );
}

export default PaymentMethodScreen;
